import { arrayOf, bool, func, number, objectOf } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

const SubCategoryItems = ({
	items = {},
	selectedItems = [],
	onSelectionChange,
	multiple = false,
	graphicsType = ''
}) => {
	const containerRef = useRef(null);
	const [showAllStyles, setShowAllStyles] = useState(false);
	const [internalSelectedItems, setInternalSelectedItems] = useState(selectedItems);

	useEffect(() => {
		setInternalSelectedItems([]);
	}, [graphicsType]);

	useEffect(() => {
		const container = containerRef.current;
		if (container) {
			if (showAllStyles) {
				container.style.height = `${container.scrollHeight}px`;
			} else {
				container.style.height = '35px';
			}
		}
	}, [showAllStyles]);

	useEffect(() => {
		if (selectedItems.length > 0 && internalSelectedItems.length === 0) {
			setInternalSelectedItems(selectedItems);
		}
	}, [selectedItems, internalSelectedItems]);

	const transformedItems = Object.keys(items).map((key) => ({
		name: key,
		count: items[key]
	}));

	const handleSelect = (item) => {
		let newSelectedItems;

		if (item === 'All') {
			if (internalSelectedItems.includes('All')) {
				// Deselect "All", clear all selected items
				newSelectedItems = [];
			} else {
				// Select all items, including 'All'
				newSelectedItems = [...transformedItems.map((item) => item.name), 'All'];
			}
		} else if (multiple) {
			if (internalSelectedItems.includes(item)) {
				// Unselect the item
				newSelectedItems = internalSelectedItems.filter((selectedItem) => selectedItem !== item);
			} else {
				// Add the selected item
				newSelectedItems = [...internalSelectedItems, item];
			}

			// Check if all items except 'All' are selected
			const allItemsSelected = newSelectedItems.length === transformedItems.length;

			// If all items (except 'All') are selected, include 'All'
			if (allItemsSelected && !newSelectedItems.includes('All')) {
				// If all items (except 'All') are selected, include 'All'
				newSelectedItems.push('All');
			} else if (!allItemsSelected) {
				// If an item is deselected, remove 'All' from selected items
				newSelectedItems = newSelectedItems.filter((selectedItem) => selectedItem !== 'All');
			}
		} else {
			// For single selection mode
			newSelectedItems = [item];
		}

		// Remove any duplicate "All" from the array (if any)
		newSelectedItems = [...new Set(newSelectedItems)];

		setInternalSelectedItems(newSelectedItems);
		onSelectionChange(newSelectedItems);
	};

	const isAllSelected = () => {
		return transformedItems.length + 1 === internalSelectedItems.length;
	};
	return (
		<div className={`sub-category-tab`}>
			<div
				ref={containerRef}
				className={`all-sub-button d-flex flex-wrap justify-content-center ${
					showAllStyles ? 'show-all' : ''
				}`}
			>
				<div>
					<div
						className={`button size32 outline mr-2 cursor-pointer ${
							isAllSelected() ? 'active' : ''
						}`}
						onClick={() => handleSelect('All')}
					>
						{isAllSelected() ? 'Unselect All' : 'Select All'}
					</div>
				</div>
				{transformedItems?.map((item, index) => (
					<div key={`transformed_item_${index}`}>
						<div
							className={`button size32 outline mr-2 cursor-pointer ${
								internalSelectedItems.includes(item.name) ? 'active' : ''
							}`}
							onClick={() => handleSelect(item.name)}
						>
							{item.name} ({item.count})
						</div>
					</div>
				))}
			</div>
			<div className={`all-button-show mt-3 mb-2 ${showAllStyles ? 'active' : ''}`}>
				<p
					className="cursor-pointer gray_dark_01 regular-14 d-inline d-flex align-items-center justify-content-center"
					onClick={() => {
						setShowAllStyles((prev) => !prev);
						//window.scrollTo(0, scrollTop);
					}}
				>
					<span className="pr-2">{showAllStyles ? 'Hide All' : 'View All'}</span>
					<span className="angel-icon">
						<img src={`${process.env.PUBLIC_URL}/icons/chevron_down.png`} width={12} />
					</span>
				</p>
			</div>
		</div>
	);
};
SubCategoryItems.propTypes = {
	items: objectOf.isRequired,
	selectedItems: arrayOf.isRequired,
	onSelectionChange: func.isRequired,
	multiple: bool,
	showAll: bool,
	isSlideShow: bool,
	scrollTop: number
};
export default SubCategoryItems;
